module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("省市选择")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', [_c('location', {
    model: {
      value: (_vm.location),
      callback: function($$v) {
        _vm.location = $$v
      },
      expression: "location"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "ml20"
  }, [_c('h4', [_vm._v(" 选择结果")]), _vm._v(" "), _c('pre', {
    staticStyle: {}
  }, [_vm._v(_vm._s(JSON.stringify(_vm.location, null, 4)))])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-460f0923"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/views/location.vue
// module id = 104
// module chunks = 1